import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Активного заказа нет ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Создать заказ ")

import { watch } from "vue";
import { useIntervalFn } from "@vueuse/shared";

import { useAsync } from "@/use/useAsync";
import { useRequests } from "@/use/useRequests";
import { useStore } from "@/use/useStore";

import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";

import UiIcon from "../../../components/ui/UiIcon.vue";
import UiCell from "@/plugins/ui/components/cell/UiCell.vue";
import UiCaption from "@/plugins/ui/components/typography/UiCaption.vue";
import UiBtn from "@/plugins/ui/components/button/UiBtn.vue";
import RequestCell from "@/features/requests/components/RequestCell.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActiveRequest',
  setup(__props) {

const { currentUser } = useStore();
const { activeRequest, fetchActiveRequest, getRequestStatus } = useRequests();

const fetchData = useAsync(fetchActiveRequest, true);
const requestChecker = useIntervalFn(fetchData.execute, 60 * 1000, {
  immediate: false,
});

// Start checker active request only if active request is exist!
watch(
  () => activeRequest.value,
  (value) => (value ? requestChecker.resume() : requestChecker.pause())
);

watch(
  () => currentUser.value?.id,
  () => {
    requestChecker.pause();
    fetchData.execute();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiCard, null, {
    header: _withCtx(() => [
      _createVNode(UiHeader, { title: "ОБЕДОМАТ (Активный заказ)" })
    ]),
    default: _withCtx(() => [
      (_unref(activeRequest))
        ? (_openBlock(), _createBlock(RequestCell, {
            key: 0,
            request: _unref(activeRequest)
          }, null, 8, ["request"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(UiCaption, { style: {"margin-bottom":"16px"} }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(UiBtn, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/requests/create'))),
              variant: "secondary",
              block: ""
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ], 64))
    ]),
    _: 1
  }))
}
}

})